<template>
  <div>
    <LoginForm v-if="!user && !verifyType" @user-is-exist="setForm" />
    <VerificationTypeForm
      v-if="isVipRole && !verifyType"
      @on-type-select="(type) => (this.verifyType = type)"
      @on-cancel="resetForm"
    />
    <PasswordForm
      v-if="user && verifyType === 'password'"
      :user="user"
      @on-cancel="verifyType = null"
    />
    <FaceRecognitionForm
      v-if="user && verifyType === 'biometrics'"
      :user="user"
      @webcam-was-disabled="handleWebcamDisabling"
    />
  </div>
</template>

<script>
import LoginForm from "@/authorization/components/LoginForm";
import FaceRecognitionForm from "@/authorization/components/FaceRecognitionForm";
import VerificationTypeForm from "@/authorization/components/VerificationTypeForm";
import PasswordForm from "@/authorization/components/PasswordForm";
import { useRoleIdentifier } from "@/_shared/mixins";
export default {
  mixins: [useRoleIdentifier],
  components: {
    LoginForm,
    FaceRecognitionForm,
    VerificationTypeForm,
    PasswordForm,
  },
  data() {
    return {
      login: "",
      user: null,
      verifyType: null,
    };
  },
  computed: {
    isVipRole() {
      if (!this.user) {
        return false;
      }
      const currentRole = this.user.role.name;
      const results = this.checkVipRole(currentRole);
      return results;
    },
  },
  methods: {
    handleWebcamDisabling() {
      this.isVipRole ? (this.verifyType = null) : this.resetForm();
    },
    setForm(data) {
      this.user = data;
      if (!this.isVipRole) {
        this.verifyType = "biometrics";
      }
    },
    resetForm() {
      this.user = null;
      this.verifyType = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/authorization/pages/LoginPage.vue